import * as React from 'react';

import Glyph from 'components/Glyph';
import MediaObject from 'components/MediaObject';
import Text, { OptionalProps as TextProps } from 'components/Text';

import { GlyphName } from '@remind/r101-glyphs';
import { GlyphColor, GlyphSize } from 'components/Glyph';
import { MediaObjectGutter } from 'components/MediaObject';

type Props = {
  children?: React.ReactNode;
  glyph: GlyphName;
  glyphColor?: GlyphColor;
  glyphSize?: GlyphSize;
  gutter?: MediaObjectGutter;
  inline?: boolean;
  center?: boolean;
} & TextProps;

/**
 * ## [Text](/internal/components/Text) with a prepended [Glyph](/internal/components/Glyph).
 *
 *
 * ```example
 * <TextWithGlyph glyph="remind-icon">
 *   Lorem ipsum dolor sit amet
 * </TextWithGlyph>
 * ```
 *
 * ```example
 * <TextWithGlyph
 *   glyph="remind-icon"
 *   glyphColor="brand"
 *   glyphSize="xlarge">
 *   Lorem ipsum dolor sit amet
 * </TextWithGlyph>
 * ```
 *
 *
 * # TODO
 * * Replace with TextWithIcon
 */

export default function TextWithGlyph(props: Props) {
  const {
    children,
    glyph,
    glyphColor = 'inherit',
    glyphSize = 'inherit',
    gutter = 'xsmall',
    inline,
    center = true,
    ...others
  } = props;

  return (
    <MediaObject center={center} gutter={gutter} inline={inline} className="TextWithGlyph">
      <Glyph name={glyph} color={glyphColor} size={glyphSize} className="TextWithGlyph-glyph" />
      <Text {...others} align="left">
        {children}
      </Text>
    </MediaObject>
  );
}
